import { render } from "./GoContacto.vue?vue&type=template&id=f9aa6110&scoped=true"
import script from "./GoContacto.vue?vue&type=script&lang=js"
export * from "./GoContacto.vue?vue&type=script&lang=js"

import "./GoContacto.vue?vue&type=style&index=0&id=f9aa6110&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9aa6110"]])

export default __exports__